import React, {useState} from "react";
import {Button, MenuItem, TextField,} from "@material-ui/core";
import {Field, Form, Formik} from "formik";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useLocation, useRouteMatch} from "react-router-dom";
import LoadingButton from "../../shared-components/loading-button/LoadingButton";
import {toggleQuickPanel} from "app/main/shared-components/quick-panel/store";
import Grid from "@material-ui/core/Grid";
import {EmailTypes, ShowEmailTypes,} from "../../../types/service-types/ReservationTypes";
import {emailStyles} from "./email.styles";
import {ReservationService} from "app/services";
import {errorMsg, successMsg} from "../../../utils/MessageUtils";
import {filterSchedules} from "../store/filter-schedules.slice";
import {AppState} from "app/store";
import DateUtils from "../../../utils/DateUtils";
import {useTranslation} from "react-i18next";

const Sms = () => {
  const classes = emailStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const {params}: any = useRouteMatch();
  const location = useLocation<any>();
  const {t} = useTranslation();

  const reservationId = params?.id;
  const emailResponses = location?.state?.emailResponses;

  const [addEmailLoading, setAddEmailLoading] = useState(false);

  const filters = useSelector(
      (state: AppState) => state.schedules.filterSchedules
  );

  const addEmail = async (params: any) => {
    try {
      setAddEmailLoading(true);
      const response = await ReservationService.addEmail(
          params.id,
          params.body
      );

      if (response.status >= 200 || response.status < 300) {
        dispatch(successMsg(localStorage.getItem('i18nextLng') === 'en' ? 'Email sent successfully!' : 'Email u dergua me sukses!'));
        if (params.onSuccess) params.onSuccess();
        dispatch(
            filterSchedules({
              ...filters,
              page: 0,
            })
        );
      }
      setAddEmailLoading(false);
    } catch (err) {
      setAddEmailLoading(false);
      let error = err.data.message;
      if (err.data.message.includes("emailType")) {
        error = "Please fill out this field";
      }
      dispatch(errorMsg(error));
      if (params.onError) params.onError();
    }
  };

  const submit = async (data: EmailTypes) => {
    const params = {
      id: reservationId,
      body: {
        emailType: data.emailType,
      },
      onSuccess: () => {
        dispatch(toggleQuickPanel());
        history.goBack();
      },
    };

    await addEmail(params);
  };

  return (
      <div className={classes.formWrapper}>
        <div className={classes.formHeader} style={{marginBottom: "35px"}}>
          <h1 style={{color: "#0D3B66"}}>{t("app.main.schedules.email.title", "Send email to the client")}</h1>
        </div>

        <div className={classes.disquisitionsWrapper}>
          {emailResponses.map((item: ShowEmailTypes, index: number) => {
            return (
                <div>
                  {index + 1 + "). "}
                  <span style={{fontWeight: 600}}>{item.fullName}</span>
                  {": "}
                  <br></br>
                  <span>EmailType: {item.emailType}</span>
                  <br></br>
                  <span style={{fontSize: "11px"}}>
                {DateUtils.toHumanDate(
                    DateUtils.convertDate(item.createdAt),
                    new Date(item.createdAt).toLocaleTimeString()
                )}
              </span>
                </div>
            );
          })}
        </div>

        <Formik
            initialValues={{
              emailType: "",
            }}
            onSubmit={(data: any) => {
              submit(data);
            }}
        >
          {({values, setValues}) => (
              <Form>
                <Field
                    variant="outlined"
                    value={values.emailType}
                    name="currency"
                    label={t("app.main.schedules.email.form.field.email", "Type of email")}
                    select
                    fullWidth
                    as={TextField}
                    onChange={(e: any) =>
                        setValues({
                          ...values,
                          emailType: e.target.value,
                        })
                    }
                >
                  <MenuItem value="PAID_INVOICE">
                    {t("app.main.schedules.email.form.menuItem.sendConf", "Send Confirmation Invoice")}
                  </MenuItem>
                  <MenuItem value="UNPAID_INVOICE">{t("app.main.schedules.email.form.menuItem.sendUnpaid", "Send Unpaid Invoice")}</MenuItem>
                  {/* this is gonna be used later when the backend is ready*/}
                  <MenuItem value="SWISS_QR_BILL">
                    {t("app.main.schedules.email.form.menuItem.sendSwissQr", "Send Swiss QR bill")}
                  </MenuItem>
                </Field>

                <Grid
                    container
                    justify="flex-end"
                    alignItems="center"
                    style={{marginTop: "20px"}}
                >
                  <Grid item>
                    <LoadingButton
                        type="submit"
                        btnTitle={t("app.main.schedules.email.form.sendButton", "Send")}
                        size="medium"
                        isLoading={addEmailLoading}
                    />
                    <Button
                        onClick={(e) => {
                          dispatch(toggleQuickPanel());
                          history.goBack();
                        }}
                    >
                      {t("app.main.schedules.splitPassenger.closeButton", "Close")}
                    </Button>
                  </Grid>
                </Grid>
              </Form>
          )}
        </Formik>
      </div>
  );
};

export default Sms;
